export default __webpack_public_path__ + "static/media/22B730C1-FC9D-43B8-8701-44921004F016_1_105_c.16a34e62.jpeg";